import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form } from 'react-bootstrap';
import { Bar, Line } from 'react-chartjs-2';
import axios from 'axios';
import 'chart.js/auto';
import { useAuth } from 'context/AuthWizardContext';

const Landing = () => {
  const [chart1Data, setChart1Data] = useState(null);
  const [chart2Data, setChart2Data] = useState(null);
  const [years, setYears] = useState([]); // Option için yıl bilgileri
  const [selectedYear, setSelectedYear] = useState(''); // Seçilen yıl
  const { user } = useAuth();

  // Chart options
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
    },
  };

  // Chart 1 için API çağrısı
  const fetchChart1Data = async () => {
    const body = {
      token: user.token,
      process: '100019334',
      year: '2024',
      customer_id: user.customerId,
    };
    try {
      const response = await axios.post('https://musteri.guardnet.com.tr/call.php', body);
      setChart1Data(response.data.chart1);

      // Eğer year bilgisi varsa, options için ayarla
      if (response.data.chart1 && response.data.chart1.length > 0) {
        const uniqueYears = [...new Set(response.data.chart1.map((item) => item.year))];
        setYears(uniqueYears);
        setSelectedYear(uniqueYears[0]); // İlk yılı varsayılan olarak seç
      }
    } catch (error) {
      console.error('Chart 1 verileri alınırken hata oluştu:', error);
    }
  };

  // Chart 2 için API çağrısı
  const fetchChart2Data = async (year) => {
    const body = {
      token: user.token,
      process: '100019335',
      year: year,
      customer_id: user.customerId,   
    };
    try {
      const response = await axios.post('https://musteri.guardnet.com.tr/call.php', body);
      setChart2Data(response.data.chart2);
    } catch (error) {
      console.error('Chart 2 verileri alınırken hata oluştu:', error);
    }
  };

  useEffect(() => {
    // İlk yüklemede Chart 1 için verileri çek
    fetchChart1Data();
  }, []);

  useEffect(() => {
    // Seçilen yıl değiştiğinde Chart 2 için verileri çek
    if (selectedYear) {
      fetchChart2Data(selectedYear);
    }
  }, [selectedYear]);

  // Kullanıcı yıl seçtiğinde tetiklenecek fonksiyon
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  // Rastgele renk üreteci
  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  // Chart 1 için verilerin işlenmesi
  const chart1Config = chart1Data
    ? {
        labels: chart1Data.map((item) => `Ay ${item.month}`),
        datasets: [
          {
            label: 'Ticket Count',
            data: chart1Data.map((item) => item.ticket_count),
            backgroundColor: 'rgba(75, 192, 192, 0.6)',
          },
        ],
      }
    : null;

  // Chart 2 için verilerin işlenmesi
  const chart2Config = chart2Data
    ? {
        labels: [...new Set(chart2Data.map((item) => `Ay ${item.month}`))], // Aylara göre benzersiz etiketler
        datasets: chart2Data.map((memberData) => ({
          label: memberData.uname, // Kullanıcı ismi
          data: chart2Data
            .filter((item) => item.uname === memberData.uname)
            .map((item) => item.event_count),
          backgroundColor: getRandomColor(), // Rastgele renk
          borderColor: getRandomColor(), // Sınır rengi
          fill: false,
        })),
      }
    : null;

  return (
    <Container fluid className="p-4">
      <Row className="g-4 mb-4">
        <Col xs={12}>
          <Card className="shadow-sm border-0 rounded-3">
            <Card.Body>
              <Card.Title className="mb-4 text-center">Destek İstatistikleri</Card.Title>

              {/* Yıl Seçimi */}
              <Form.Group controlId="yearSelect" className="mb-4">
                <Form.Label>Yıl Seçin</Form.Label>
                <Form.Control as="select" value={selectedYear} onChange={handleYearChange}>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              {/* Chart 1 */}
              {chart1Config && (
                <div style={{ height: '300px' }}>
                  <Bar data={chart1Config} options={chartOptions} />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="g-4">
        <Col xs={12}>
          <Card className="shadow-sm border-0 rounded-3">
            <Card.Body>
              <Card.Title className="mb-4 text-center">
                Etkinlik İstatistikleri {/* Uname bilgisi her bir data setiyle gösteriliyor */}
              </Card.Title>
              {/* Chart 2 */}
              {chart2Config && (
                <div style={{ height: '300px' }}>
                  <Bar data={chart2Config} options={chartOptions} />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Landing;
